import React from 'react';
import { Box, Container } from '@mui/material';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';

const Main = ({ sections }) => {
  return (
    <>
      <Navbar sections={sections} />
      <Box sx={{ height: { xs: 64, md: 72 } }} />
      <Box component="main">
        {sections.map(({ id, component: SectionComponent, fullBleed }, index) => (
          <Box
            id={id}
            key={id}
            component="section"
            sx={{
              scrollMarginTop: { xs: 80, md: 100 },
              py: fullBleed ? 0 : { xs: 8, md: 12 },
              bgcolor: index % 2 === 1 ? 'background.paper' : 'transparent',
            }}
          >
            {fullBleed ? (
              <SectionComponent />
            ) : (
              <Container>
                <SectionComponent />
              </Container>
            )}
          </Box>
        ))}
      </Box>
      <Footer />
    </>
  );
};

export default Main;
